
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"42","viewBox":"0 0 46 42"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#C3AFA3","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2.813"}},[_c('path',{attrs:{"d":"M31.815 40.52l-7.248-5.891a3.114 3.114 0 01-1.083-3.193 3.123 3.123 0 011.73-2.077 3.146 3.146 0 012.71.043l2.246 1.122V17.667a2.863 2.863 0 012.87-2.857 2.864 2.864 0 012.87 2.857v8.571l3.812.634a5.721 5.721 0 014.796 5.637v8.015M1.474 11.949h14.348M8.648 4.806l-7.174 7.143 7.174 7.142"}}),_c('path',{attrs:{"d":"M24.923 21.459a11.394 11.394 0 010-16.162c4.483-4.463 11.75-4.463 16.233 0a11.394 11.394 0 010 16.162"}})])])
          )
        }
      }
    